import { render, staticRenderFns } from "./FooterPartners.vue?vue&type=template&id=713fe747&scoped=true"
import script from "./FooterPartners.vue?vue&type=script&lang=js"
export * from "./FooterPartners.vue?vue&type=script&lang=js"
import style0 from "./FooterPartners.vue?vue&type=style&index=0&id=713fe747&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713fe747",
  null
  
)

export default component.exports